import { useAuth } from '../state/AuthProvider';
import { Shell } from '../ui/PwaContent';

export function ProfileView() {
  const { auth } = useAuth();

  return (
    <Shell title="Profil" subtitle="Benutzerdaten, Kinderaccounts und Benachrichtigungen.">
      <div className="grid gap-4 md:grid-cols-2">
        <section className="wwpwa-panel">
          <h2 className="font-bold">Benutzer</h2>
          <p className="mt-2"><strong>{auth.user?.real_name}</strong></p>
          <p className="text-sm text-gray-600">{auth.user?.email}</p>
          <p className="mt-2 text-sm text-gray-600">Gruppen: {auth.groups.join(', ')}</p>
        </section>
        <section className="wwpwa-panel">
          <h2 className="font-bold">Kinderaccounts</h2>
          <p className="mt-2 text-sm text-gray-600">Kommt im nächsten Schritt.</p>
        </section>
      </div>
    </Shell>
  );
}
